export function filterReservationPartiesWithAddNew(
  options: any[],
  { inputValue }: { inputValue: string }
) {
  const search = inputValue.trim();
  const normalizedSearch = normalizeLookupText(search);

  if (search.length <= 1) {
    return options;
  }

  const hasAddNewOption = options.some((option) => option?.value === '__new__');
  if (hasAddNewOption) {
    return options;
  }

  const hasExactMatch = options.some((option) => {
    if (!option || typeof option.label !== 'string') {
      return false;
    }

    return normalizeLookupText(option.label) === normalizedSearch;
  });

  if (hasExactMatch) {
    return options;
  }

  return [
    ...options,
    {
      label: `➕ Dodaj nową stronę: "${search}"`,
      value: '__new__',
    },
  ];
}

function normalizeLookupText(value: string): string {
  return value
    .trim()
    .toLocaleLowerCase('pl-PL')
    .replace(/\s+/g, ' ');
}
